export const globalFlatpickrConfig = {
    allowInput: false,
    altInput: true,
    altFormat: 'l, F j, Y',
    locale: {
        firstDayOfWeek: 0 // start week on Sunday
    },
    dateFormat: 'Z',
    onClose: (selectedDates: any, dateStr: any, instance: any) => {
        // This sets the date to what is in the input box when tabbing off of the date.
        instance.setDate(instance._input.value, true, instance.config.altFormat);
    },
};
